import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=699803c2&lang=pug&"
import script from "./PageNotFound.vue?vue&type=script&lang=js&"
export * from "./PageNotFound.vue?vue&type=script&lang=js&"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('699803c2')) {
      api.createRecord('699803c2', component.options)
    } else {
      api.reload('699803c2', component.options)
    }
    module.hot.accept("./PageNotFound.vue?vue&type=template&id=699803c2&lang=pug&", function () {
      api.rerender('699803c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PageNotFound.vue"
export default component.exports